export default __webpack_public_path__ + "static/media/right_sidebar_hold.cf955bfe.svg";